export default __webpack_public_path__ + "static/media/handing.6921d52b.hbs";